<template>
  <el-dialog title="指定訂閱選項" :visible.sync="innerVisible" append-to-body>
    <el-form :model="form" ref="form" >
      <el-form-item label="需要審核" :label-width="formLabelWidth">
        <el-switch
          v-model="form.isNeedApprove"
          active-text="是"
          inactive-text="否"
        ></el-switch>
      </el-form-item>

      <el-form-item label="指定到期日" :label-width="formLabelWidth">
        <el-switch
          v-model="form.hasEndDate"
          active-text="是"
          inactive-text="否"
        ></el-switch>
      </el-form-item>

      <div v-if="form.hasEndDate">
        <el-form-item label="到期日" :label-width="formLabelWidth">
          <el-date-picker
            v-model="form.endDate"
            :picker-options="pickerOptions"
            style="width:150px"
            type="date"
            :clearable="false"
            value-format="timestamp"
            size="small"
            placeholder="指定到期日"
          >
          </el-date-picker>
        </el-form-item>
      </div>
    </el-form>

    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">確 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import moment from "moment-timezone";
import { MAX_DUEDATE } from "@/appConfig";
export default {
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > MAX_DUEDATE;
        },
        shortcuts: [
          {
            text: "一周後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(1, "weeks")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一個月後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(1, "months")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
          {
            text: "三個月後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(3, "months")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一年後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(1, "years")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      formLabelWidth: "100px",
      form: {
        endDate: null,
        hasEndDate: false,
        isNeedApprove: false,
      },
    };
  },
  created() {
    if (this.innerVisible) {
      this.form.endDate = moment()
        .startOf("day")
        .valueOf();
    }
  },
  methods: {
    submit() {
      this.innerVisible = false;
      this.$emit("startSubs", this.form);
    },
  },
};
</script>

<style></style>
